// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"b5576311","738":"ba8bd624","919":"0562c7e3"}[chunkId] + ".chunk.js";
};